import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

import HomePage from "./pages/HomePage";
import ApplyPage from "./pages/ApplyPage";
import PrivacyPage from "./pages/PrivacyPage";
import CoveragesPage from "./pages/CoveragesPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import PreApprovalPage from "./pages/PreApprovalPage";
import BusinessLoansPage from "./pages/BusinessLoansPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/coverages" element={<CoveragesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/get-preapproved" element={<PreApprovalPage />} />
            <Route path="/applynow" element={<HomePage />} />
            <Route path="/businessloans" element={<BusinessLoansPage />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
